import { FC } from "react";
import MaterialGrid from "@mui/material/Grid";

import { IProps } from "./types";

export const Grid: FC<IProps> = (props) => <MaterialGrid {...props}>{props.children}</MaterialGrid>;
